import React from "react";

import { panelHeaderStyle } from "./styles";

const Title = ({ style, children }) => (
  <p style={{ ...panelHeaderStyle, ...style }}>{children}</p>
);

export default Title;



// WEBPACK FOOTER //
// ./src/components/analysis/Title.js